<template>
  <div class="row bgc-wrapper margin-top-42">
    <MultiServiceLoader :status="state.multiServiceLoaderStatus" :enabled="showRegLoader" v-if="showRegLoader"></MultiServiceLoader>
    <div class="col-12 traveller-heading">
      <div class="row">
        <div>
          <button
            type="button"
            class="expand-form-button pt-1"
            data-toggle="collapse"
            aria-label="Expand Journey Details"
            data-target="#vehDetails"
          >
            <img alt="Toggle Journey Details" src="@/assets/images/arr-up.png" />
          </button>
        </div>
        <div class="col-3 p-0">
              <h3>Vehicle Details</h3>
        </div>
        <div class="col">
              <span class="mandatory-text float-right">All fields marked with * are mandatory</span>
        </div> 
      </div>
    </div>
    <div class="collapse show col-12 bgc-form-box" id="vehDetails">
      <div class="row">
        <!-- Radial progress bar stars -->
        <div class="col-lg-3 col-md-3 col-sm-12 p-0 radial-class w-100 pt-0 pr-lg-0 pb-2 pl-lg-5 d-flex flex-column align-items-center">
          <div class="mobile-label text-center mt-2 mb-2">All fields marked with * are mandatory</div>
            <radial-progress-bar class="radial-margin" :diameter="80"
                :completed-steps="steps.completed"
                :total-steps="steps.totalSteps"
                :startColor ="state.customerProgressBar.startColor"
                :stopColor ="state.customerProgressBar.stopColor"
                :innerStrokeColor="state.customerProgressBar.innerStrokeColor"
                >
                {{steps.completed}}/{{steps.totalSteps}}
            </radial-progress-bar>
            <div class="progress-mandatory text-center">
              MANDATORY STEPS
            </div>
            <div class="progress-completed text-center">
              COMPLETED
            </div>
        </div>
        <!-- Radial progress bar end -->
        <!--Vehicle Vehicle Classification* starts-->
        <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0 veh-class">
          <float-label label="Vehicle Type*" :fixed='isFloat(vehicleData.vehicleType.value)'>
            <select
              class="form-control vehicle-type"
              placeholder="Vehicle Type*"
              :class="{ 'bgc-error-field': vehicleData.vehicleType.errorText!=='' }"
              v-model="vehicleData.vehicleType.value"
              v-evolvews= "vehicleData.vehicleType"
              :disabled="vehicleData.vehicleType.disabled || isModify"
              @change='resetVehicleData()'
            >
              <option disabled value>Vehicle Type*</option>
              <option v-for="vehicleType in vehicleDb.vehicleType" :key="vehicleType.code" :value="vehicleType.code">{{vehicleType.name}}</option>
            </select>
          </float-label>
          <span class="error-text" v-if="vehicleData.vehicleType.errorText!==''">{{vehicleData.vehicleType.errorText}}</span>
        </div>
        <!--Vehicle Classification* end-->
      </div>
      <div class="vehicle row" :class="{ 'disablePinFields': vehicleData.vehicleType.value=='' }">
        <div class="col-lg-3 col-md-3 col-sm-6 p-0">
        <!--Vehicle Registration Number* starts-->
          <RegNumSearch :registrationData="vehicleData.registrationNo" :enabled="state.loaderEnabled" @setvehicledetails="setRegData" :isModify="isModify" :showRegLoader="showRegLoader" :dataFetchedFrom="vehicleDb.dataFetchedFrom" fromSource="PIN"></RegNumSearch>
        <!--Vehicle Registration Number* ends-->
        </div>
        <!--Registration Location starts-->
          <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0" :class="{ 'disablePinFields': vehicleData.registrationNo.value==''}">
            <float-label label="Registration Location*" :fixed="isFloat(vehicleData.rtaLocationCode.value)">
              <v-select
                :map-keydown="handlersRta" 
                :disabled=" vehicleDb.registrationLocation.length<=1 "
                class="v-select-form form-control rtaLocationCode"
                :class="{'bgc-error-field': vehicleData.rtaLocationCode.errorText !== '',
                'remove_placeholder': vehicleData.rtaLocationCode.value }"
                placeholder="Registration Location*"
                :options="intrimRegLocList"
                v-model="vehicleData.rtaLocationCode.value"
                v-evolvews="vehicleData.rtaLocationCode"
                @input="callRtaDetails()"
                :reduce="intrimRegLocList => intrimRegLocList.value"
              >
              </v-select>
            </float-label>
            <span
              class="error-text"
              v-if="vehicleData.rtaLocationCode.errorText!==''"
            >{{vehicleData.rtaLocationCode.errorText}}</span>
          </div> 
        <!--Registration Location ends-->
        <!--Vehicle Make Model* starts-->
        <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0" :class="{ 'disablePinFields': vehicleData.registrationNo.value==''}">
          <float-label label="Vehicle Make Model*" :fixed='isFloat(vehicleData.make_model.value)'>
            <v-select
              :map-keydown="handlersMakeModel"
              class="v-select v-select-form form-control make-model vs--single vs--searchable "
              :class="{ 'bgc-error-field': vehicleData.make_model.errorText!=='','remove_placeholder': vehicleData.make_model.value }"
              v-model="vehicleData.make_model.value"
              v-evolvews= "vehicleData.make_model"
              placeholder="Vehicle Make Model*"
              :disabled="vehicleDb.vehicleMakeModelList.length==0 || loaderShowMakeModel || isModify"
              :options="intrimMakeModelList"
              :reduce="intrimMakeModelList => intrimMakeModelList.value"
              @input="getVehicleSubTypeList()"
            >
            </v-select>
          </float-label>
          <span class="error-text" v-if="vehicleData.make_model.errorText!==''">{{vehicleData.make_model.errorText}}</span>
          <span class="loader-small-make_model loader-show-class" v-show="loaderShowMakeModel">
                <img src="@/assets/images/loader.gif" alt="make_model-loader">
          </span>
        </div>
        <!--Vehicle Make Model* ends-->
        <!--Vehicle Sub Type starts-->
        <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0" :class="{ 'disablePinFields': vehicleData.registrationNo.value==''}">
          <float-label label="Vehicle Sub Type*" :fixed='isFloat(vehicleData.vehicleSubType.value)'>
            <v-select
              :map-keydown="handlersSubtype"
              class="v-select v-select-form form-control subtype"
              :class="{ 'bgc-error-field': vehicleData.vehicleSubType.errorText!=='','remove_placeholder': vehicleData.vehicleSubType.value }"
              v-model="vehicleData.vehicleSubType.value"
              v-evolvews= "vehicleData.vehicleSubType"
              placeholder="Vehicle Sub Type"
              :disabled="vehicleDb.vehicleSubTypeList.length<2 || isModify"
              :options="intrimSubTypeList"
              :reduce="intrimSubTypeList => intrimSubTypeList.value"
              @search:blur="checkError(vehicleData.vehicleSubType,false)+setErrorClass(vehicleData.vehicleSubType,'subtype')+setVehicleDataFromSubtype()"
            >
            </v-select>
          </float-label>
          <span
            class="error-text"
            v-if="vehicleData.vehicleSubType.errorText!==''"
          >{{vehicleData.vehicleSubType.errorText}}</span>
          <p class="small gap" v-if="vehicleData.vehicleSubType.value"> 
              <span v-show="vehicleDb.fuelType.toUpperCase() !== 'BATTERY(B)' && vehicleDb.fuelType.toUpperCase() !== 'BATTERY' && vehicleDb.fuelType.toUpperCase() !== 'B' && vehicleDb.cubicCapacity">CC: </span>
              <span v-show="vehicleDb.fuelType.toUpperCase() == 'BATTERY(B)' || vehicleDb.fuelType.toUpperCase() == 'BATTERY' || vehicleDb.fuelType.toUpperCase() == 'B' && vehicleDb.cubicCapacity">KW:</span>   
              <span class="font-weight-bold" v-if="vehicleDb.cubicCapacity">{{vehicleDb.cubicCapacity}}, &nbsp;</span>
              <span v-show="vehicleDb.vehicleGVW"> GVW: </span>   <span class="font-weight-bold" v-show="vehicleDb.vehicleGVW">{{vehicleDb.vehicleGVW}}, &nbsp;</span>
              <span>Fuel: </span><span class="font-weight-bold">{{getFuelType(vehicleDb.fuelType)}}</span>
          </p>
        </div>
        <!--Vehicle Sub Type ends-->
        <!--Year Of Manufacture starts-->
        <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0" :class="{ 'disablePinFields': vehicleData.registrationNo.value==''}">
          <float-label label="Year Of Manufacture*" :fixed='isFloat(vehicleData.yearOfManufacture.value)'>
            <datepicker
              v-model="vehicleData.yearOfManufacture.value"
              format="yyyy"
              minimum-view='year'
              class="man_year"
              id="year_of_manufacture"
              :input-class="isInputError(vehicleData.yearOfManufacture.errorText)"
              :disabled="isModify"
              :disabledDates="{from: new Date()}"
              placeholder="Year Of Manufacture*"
              @datePickerBlurred="checkError(vehicleData.yearOfManufacture,false)"
            ></datepicker>
          </float-label>
          <span
            class="error-text"
            v-if="vehicleData.yearOfManufacture.errorText!==''"
          >{{vehicleData.yearOfManufacture.errorText}}</span>
        </div>
        <!--Year Of Manufacture ends-->
        <!--Date of Registration starts-->
        <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0" :class="{ 'disablePinFields': vehicleData.registrationNo.value==''}">
          <float-label label="Date of Registration*" :fixed='isFloat(vehicleData.dateOfRegistration.value)'>
            <datepicker
              v-model="vehicleData.dateOfRegistration.value"
              :typeable="true"
              format="dd/MM/yyyy"
              :disabled="isModify"
              :open-date="openDate"
              id="date_of_registration"
              :input-class="isInputError(vehicleData.dateOfRegistration.errorText)"
              placeholder="Date of Registration*"
              :disabledDates="{from: new Date(), to: getStartRegYear}"
              @datePickerBlurred="checkError(vehicleData.dateOfRegistration,false)"
            ></datepicker>
          </float-label>
          <span
            class="error-text"
            v-if="vehicleData.dateOfRegistration.errorText!==''"
          >{{vehicleData.dateOfRegistration.errorText}}</span>
        </div>
        <!--Date of Registration ends-->
        <!--Engine Number starts-->
        <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0" :class="{ 'disablePinFields': vehicleData.registrationNo.value==''}">
          <float-label :label="(vehicleData.registrationNo.values[0] == 'NE' && vehicleData.registrationNo.values[1] == 'W')?'Engine Number*':'Engine Number'" :fixed='isFloat(vehicleData.engineNumber.value)'>
            <input
              type="text"
              :placeholder="(vehicleData.registrationNo.values[0] == 'NE' && vehicleData.registrationNo.values[1] == 'W')?'Engine Number*':'Engine Number'"
              class="form-control capital-input"
              maxlength="30"
              :class="{'bgc-error-field':vehicleData.engineNumber.errorText !== '' && vehicleData.registrationNo.values[0] == 'NE' && vehicleData.registrationNo.values[1] == 'W'}"
              v-evolvews= "vehicleData.engineNumber"
              v-model="vehicleData.engineNumber.value"
              v-on:keyup="makeChaEngUpperCase($event, 'ENGINE')"
              :disabled="isModify"
            />
          </float-label>
          <span
            class="error-text"
            v-if="vehicleData.engineNumber.errorText!=='' && vehicleData.registrationNo.values[0] == 'NE' && vehicleData.registrationNo.values[1] == 'W'"
            >{{vehicleData.engineNumber.errorText}}</span>
        </div>
        <!--Engine Number ends-->
        <!--Chasis Number starts-->
        <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0" :class="{ 'disablePinFields': vehicleData.registrationNo.value==''}">
          <float-label :label="(vehicleData.registrationNo.values[0] == 'NE' && vehicleData.registrationNo.values[1] == 'W')?'Chassis Number*':'Chassis Number'" :fixed='isFloat(vehicleData.chassisNumber.value)'>
            <input
              type="text"
              :placeholder="(vehicleData.registrationNo.values[0] == 'NE' && vehicleData.registrationNo.values[1] == 'W')?'Chassis Number*':'Chassis Number'"
              class="form-control capital-input"
              maxlength="30"
              :class="{'bgc-error-field':vehicleData.chassisNumber.errorText !== '' && vehicleData.registrationNo.values[0] == 'NE' && vehicleData.registrationNo.values[1] == 'W'}"
              v-evolvews= "vehicleData.chassisNumber"
              v-model="vehicleData.chassisNumber.value"
              v-on:keyup="makeChaEngUpperCase($event, 'CHASSIS')"
              :disabled="isModify"
            />
          </float-label>
          <span
            class="error-text"
            v-if="vehicleData.chassisNumber.errorText!=='' && vehicleData.registrationNo.values[0] == 'NE' && vehicleData.registrationNo.values[1] == 'W'"
            >{{vehicleData.chassisNumber.errorText}}</span>
        </div>
      </div> 
    </div>
  </div>
</template>

<script>
import FloatLabel from "@/../../shared_component/FloatLabel.vue";
import Datepicker from "vuejs-datepicker";
import RegNumSearch from "@/../../shared_motor_component/RegNumSearch";
import functions from '@/../../masters/functions.js';
import RadialProgressBar from 'vue-radial-progress'; 
import { reactive, computed } from '@vue/composition-api';
import vSelect from "vue-select";
import moment from "moment";
import "vue-select/dist/vue-select.css";

export default {
  name: "VehicleDetails",
  props: ["vehicleData","vehicleDb","isModify", "steps","loaderShowMakeModel","showRegLoader"],
  components: {
    FloatLabel,
    Datepicker,
    RegNumSearch,
    vSelect,
    RadialProgressBar
  },
  setup(props, context){
    let state = reactive({
        loaderEnabled: false,
        checkQuickTabReg:false,
        customerProgressBar : {
          startColor : '#007bff',
          stopColor: '#007bff',
          innerStrokeColor: '#D3D3D3'
        },
        multiServiceLoaderStatus:'Loading'

    });
    //computed
    const totalSteps = computed(()=>{
        return 8;
    });
    const completedSteps = computed(()=>{
        let count = 0;
        if((props.vehicleData.registrationNo.values.filter((val,index)=> index!= 2).every(val=> val!="") || props.vehicleData.registrationNo.value == 'NEW') && props.vehicleData.registrationNo.errorText =='') 
          count++;
        if(props.vehicleData.vehicleType.value!='' && props.vehicleData.vehicleType.errorText =='') 
          count++;
        if(props.vehicleData.make_model.value!='' && props.vehicleData.make_model.errorText =='') 
          count++;
        if(props.vehicleData.vehicleSubType.value!='' && props.vehicleData.vehicleSubType.errorText =='') 
          count++;  
        if(props.vehicleData.rtaLocationCode.value!='' && props.vehicleData.rtaLocationCode.errorText =='') 
          count++; 
        if(props.vehicleData.dateOfRegistration.value)
          count++;   
        if(props.vehicleData.yearOfManufacture.value)
          count++; 
        return count;
    });
    const openDate = computed(() =>{
      if(props.vehicleData.yearOfManufacture.value){
        let manufactureYear = (props.vehicleData.yearOfManufacture.value instanceof Date) ? props.vehicleData.yearOfManufacture.value.getFullYear() : props.vehicleData.yearOfManufacture.value;
        let startDate;
        startDate = new Date('01/01/'+manufactureYear);
        return startDate;
      }
      else{
        return null;
      }
    });
    const getStartRegYear = computed(()=> {
      if(props.vehicleData.yearOfManufacture.value){
        if(props.vehicleData.yearOfManufacture.value instanceof Date){
          let yearofmanufacture = new Date(props.vehicleData.yearOfManufacture.value).getFullYear() - 1;
          let endDate = new Date(yearofmanufacture, 12, 1);
          return new Date(new moment(endDate).startOf('date').toDate());
        }else{
          let yearofmanufacture = +props.vehicleData.yearOfManufacture.value - 1;
          let endDate = new Date(yearofmanufacture, 12, 1);
          return new Date(new moment(endDate).startOf('date').toDate());
        }
      }else{
        return null;
      }
    });
    //methods
    const checkError= functions.checkError;
    const isFloat= functions.isFloat;
    const removeErrorIfNotBlank= functions.removeErrorIfNotBlank;
    const isInputError= functions.isInputError;
    const callVehicleMakeModel = (()=>{
      context.parent.resetGeneratePinDetails("VEHICLE_DETAILS", 'vehicleType');
      context.parent.getVehicleMakeModelList();
    });
    function setVehicleDataFromSubtype(){
      context.parent.setVehicleDataFromSubtype();
    }
    function getFuelType(fuelType){
      if(fuelType){
        if(fuelType == 'P')
          return 'Petrol';
        else if(fuelType == 'D')
          return 'Diesel';
        else if(fuelType == 'B' || fuelType == 'BATTERY(B)' || fuelType == 'BATTERY')
          return 'Battery';
        else if(fuelType == 'C' || fuelType == 'CNG')
          return 'CNG';
        else if(fuelType == 'PH')
          return 'Petrol Hybrid';
        else if(fuelType == 'DH')
          return 'Diesel Hybrid';
        else if(fuelType == 'H')
          return 'Hybrid';
        else
          return fuelType;
      }
      return '';
    }
    function setRegData(e, calledFromGetPinDetails){
      setTimeout(function(){if(e.target.placeholder == "Vehicle Registration Number*") e.target.placeholder = ""},10) //placeholder fix for first box in reg no
      if(!state.checkQuickTabReg){
        state.checkQuickTabReg = true;
        setTimeout(() => {
          state.checkQuickTabReg = false;
        }, 500);
        let regNum = props.vehicleData.registrationNo;
        context.root.$set(props.vehicleData.chassisNumber,'skip', true);
        context.root.$set(props.vehicleData.engineNumber,'skip', true);
        context.root.$set(props.vehicleData.chassisNumber,'required', false);
        context.root.$set(props.vehicleData.engineNumber,'required', false);
        if(/[0-9]{2}/.test(regNum.values[0]) && regNum.values[1] == 'BH'){
          if(regNum.values.every(val=> val != "") && !regNum.errorText){
            props.vehicleData.registrationNo.value = regNum.values.join('-');
            props.vehicleData.registrationNo.errorText = "";
            context.parent.resetGeneratePinDetails('VEHICLE_DETAILS', 'registrationNo');
            context.parent.getRtaLocation(calledFromGetPinDetails, true);
          }else{
            context.parent.resetGeneratePinDetails('VEHICLE_DETAILS', 'registrationNo');
          }
        }else{
          if(regNum.values.filter((val,index)=> index!= 2).every(val=> val!="") && regNum.errorText==''){
            props.vehicleData.registrationNo.value = regNum.values[2] ? regNum.values.join('-'): [regNum.values[0],regNum.values[1],regNum.values[3]].join('-');
            props.vehicleData.registrationNo.errorText = "";
            context.parent.resetGeneratePinDetails('VEHICLE_DETAILS', 'registrationNo');
            context.parent.getRtaLocation(calledFromGetPinDetails);
          }
          else 
          {
            if(props.vehicleData.registrationNo.value == 'NEW'){
              context.parent.resetGeneratePinDetails('VEHICLE_DETAILS', 'registrationNo');
              context.parent.getRtaLocation(calledFromGetPinDetails, true);
              context.root.$set(props.vehicleData.chassisNumber,'skip', undefined);
              context.root.$set(props.vehicleData.engineNumber,'skip', undefined);
              context.root.$set(props.vehicleData.chassisNumber,'required', true);
              context.root.$set(props.vehicleData.engineNumber,'required', true);
            }
          }
        }
      }
    }
    const resetVehicleData = (()=>{
      context.parent.resetGeneratePinDetails('VEHICLE_DETAILS', 'vehicleType');
      setTimeout(3000);
    })
    const handlersRta = (map) => ({
      ...map,
      8 : (e)=>{
        const elementDivRta = document.querySelector('.rtaLocationCode');
        if(!elementDivRta.classList.contains("vs--searching")){
          e.preventDefault();
        }
      }
    });
    const intrimRegLocList = computed(()=>
      props.vehicleDb.registrationLocation.map(obj=>{
        return {
          label: obj.rtaLocationCode+" - "+obj.rtaLocationName,
          value: obj.rtaLocationCode+"-"+obj.rtaLocationName
        }
      })
    );
    const intrimMakeModelList = computed(()=>
      props.vehicleDb.vehicleMakeModelList.map(obj=>{
        return {
          label: obj.makeModelName,
          value: obj.makeModelCode
        }
      })
    );
    const handlersMakeModel = (map) => ({
      ...map,
      8 : (e)=>{
        const elementDivMakeModel = document.querySelector('.make-model');
        if(!elementDivMakeModel.classList.contains("vs--searching")){
          e.preventDefault();
        }
      }
    });
    const handlersSubtype = (map) => ({
      ...map,
      8 : (e)=>{
        const elementDivSubtype = document.querySelector('.subtype');
        if(!elementDivSubtype.classList.contains("vs--searching")){
          e.preventDefault();
        }
      }
    });
    const intrimSubTypeList = computed(()=>
      props.vehicleDb.vehicleSubTypeList.map(obj=>{
        return {
          label: obj.name,
          value: obj.code
        }
      })
    );
    function getVehicleSubTypeList(){
      context.parent.getVehicleSubTypeList();
    }
    function callRtaDetails(){
      context.parent.getRtaDetails();
    }
    function makeChaEngUpperCase(evt, source){
      if(source == 'CHASSIS')
        props.vehicleData.chassisNumber.value = evt.target.value.toUpperCase();
      if(source == 'ENGINE')
        props.vehicleData.engineNumber.value = evt.target.value.toUpperCase();
    }
    function setErrorClass(objToCheck,selector){
      if(objToCheck.value == "" || objToCheck.value == null){
        objToCheck.errorText = objToCheck.errorMessage;
        $("."+selector).find("input")[0].classList.add("v-select-error-field");
      }
      else{
        objToCheck.errorText = "";
        $("."+selector).find("input")[0].classList.toggle("v-select-error-field",false)
      }
    }
    //return
    return{
      state,
      completedSteps,
      totalSteps,
      checkError,
      isFloat,
      removeErrorIfNotBlank,
      isInputError,
      callVehicleMakeModel,
      setRegData,
      getFuelType,
      resetVehicleData,
      intrimMakeModelList,
      getStartRegYear,
      callRtaDetails,
      handlersMakeModel,
      handlersSubtype,
      intrimSubTypeList,
      setErrorClass,
      handlersRta,
      openDate,
      makeChaEngUpperCase,
      intrimRegLocList,
      setVehicleDataFromSubtype,
      getVehicleSubTypeList
    }
  },
  directives: {
    evolvews: functions.evolvews
  },
}
</script>

<style>
  .vs__open-indicator {
      position: absolute;
      top: 22px;
      right: 12px;
  }
  .vs--disabled .vs__search{
    background : none;
  }    
  .vs--disabled .vs__dropdown-toggle{
    display: block;
    background: transparent;
  }
  .vs__dropdown-toggle{
    border: none;
    padding: 0px;
  }
  .v-select{
    min-height: 50px;
  }
  .vs__clear{
    display: none
  }
  input.vs__search{
    font-size:14px;
    color: #333;
    padding: 0px;
  }
  .vs__selected{
    padding-left: 0px;
    margin-left: 0px;
    text-overflow : ellipsis;
    white-space: nowrap;
    width: 274.5px;
    overflow: hidden;
    display: block;
  }
  .vs__selected-options{
    padding: 0px 1px;
  }
  .vs__selected-options{
    padding: 0px 1px;
  }
  .v-select{
    min-height: 50px;
  }
  .v-select-error-field{
    color: #f77a7a !important
  }
  .v-select-form.remove_placeholder input::-webkit-input-placeholder {
    color: transparent;
  }
  .v-select-form.remove_placeholder input::-moz-placeholder {
    color: transparent;
  }
  .v-select-form.remove_placeholder input:-ms-input-placeholder {
    color: transparent;
  }
  .v-select-form.remove_placeholder input:-moz-placeholder {
    color: transparent;
  }
  .v-select-form.remove_placeholder input::placeholder {
    color: transparent;
  }
  .v-select-form.form-control{
    font-size:14px;
    padding-top: 8px;
  }
</style>
<style scoped>
.loader-small-make_model img{
  max-width: 28px;
  position: absolute;
  top: 24%;
  right: 15%;
}
.disablePinFields{
  pointer-events:none;
  opacity: 0.5;
}
.background {
  margin-top: 20px;
  background-color: gainsboro;
  width: 100%;
}
.man_year .form-control{
  opacity: 1;
  cursor:text;
}
.info1 {
  margin: 1.2% 0;
}
.sizing {
  padding-left: 20px;
}
.gap{
  margin-bottom: -17px;;
}
.mandatory-text{
  font-style: italic;
  font-size: 14px;
}
.progress-mandatory{
  font-size: 11px;
}
.progress-completed{
  font-size: 11px;
}
.radial-margin{
  margin : auto;
}
.mobile-label{
  display: none;
}
/* @media (min-width: 992px)
  .pl-lg-5 {
      padding-left: 25rem!important;
  } */

@media (max-width: 920px) {
  .mandatory-text {
    font-size: 12px;
  }
  .progress-mandatory {
    font-size: 9px;
  }
  .progress-completed {
    font-size: 9px;
  }
}
@media (min-width: 767px) {
  .radial-class{
    left: 77%;
  }
  .veh-class{
    right: 25%;
  }
}
@media (max-width: 575px) {
  .mobile-label{
  font-size: 12px;
  display: block;
  }
 .mandatory-text{
   display: none;
 }
  .progress-mandatory {
    font-size: 9px;
  }
  .progress-completed {
    font-size: 9px;
  }
}
.capital-input{
  text-transform:uppercase;
}
::-webkit-input-placeholder { /* WebKit browsers */
  text-transform: none;
}
:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
  text-transform: none;
}
::-moz-placeholder { /* Mozilla Firefox 19+ */
  text-transform: none;
}
:-ms-input-placeholder { /* Internet Explorer 10+ */
  text-transform: none;
}
::placeholder { /* Recent browsers */
  text-transform: none;
}
</style>